export default {"src":"/_next/static/media/dark_bg_logo.c5116a3c.svg","height":35,"width":200,"blurWidth":0,"blurHeight":0};